import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { CommonService } from '@/services/Common.service';
import { AuthenService } from '@/services/authen.service';

export class RequestsService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private token = localStorage.getItem('token');
    private commonService = new CommonService();
    private authService = new AuthenService();

    constructor() {
        super();
    }

    public async getStaff() {
        const options = {
            headers: {
                'Content-Type': 'application/json',
                'auth': this.token,
            },
        };
        const kyotenCd = localStorage.getItem('kyotenCd');
        return await toData(Axios.get<AxiosResponse>(`${this.baseAPI}/staffs?q=kyotenCd=${kyotenCd}`, options));
        
    }

    async saveStaffRole(data: any) {
        // const { result, error } = await this.commonService.put(`${this.baseAPI}/staffs/`, {
        //     ...data
        // });
        // if (result) {
        //     return result.status;
        // } else {
        //     this.authService.handleError(error, 'saveStaffs');
        //     return;
        // }
    }
}
